import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, resolveComponent as _resolveComponent } from "vue";
import _imports_0 from './assets/images/logo.png';
const _hoisted_1 = {
    key: 2,
    class: "col navbar"
};
const _hoisted_2 = { class: "container-fluid px-1" };
const _hoisted_3 = ["title"];
const _hoisted_4 = { class: "col text-center menulogo subtitle" };
const _hoisted_5 = { class: "nav navbar-nav ml-auto" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "row mx-0 flex-nowrap" };
const _hoisted_8 = { class: "col px-0 mt-4" };
const _hoisted_9 = { id: "content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_view = _resolveComponent("router-view");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["wrapper app", { 'login-screen': $setup.isLogin() }])
    }, [
        _createVNode($setup["BToastOrchestrator"]),
        ($setup.currentUserStore.user)
            ? (_openBlock(), _createBlock($setup["EditUser"], {
                key: 0,
                ref: "editUser"
            }, null, 512))
            : _createCommentVNode("", true),
        ($setup.currentUserStore.user)
            ? (_openBlock(), _createBlock($setup["ChangeTenant"], {
                key: 1,
                ref: "changeTenantModal"
            }, null, 512))
            : _createCommentVNode("", true),
        _createVNode($setup["ChangeLanguage"], { ref: "changeLanguageModal" }, null, 512),
        (!$setup.isLogin())
            ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "sidebar-header py-1",
                        title: $setup.version
                    }, [
                        _cache[1] || (_cache[1] = _createElementVNode("h4", null, [
                            _createElementVNode("img", {
                                class: "menulogo logo",
                                src: _imports_0
                            }),
                            _createElementVNode("span", { class: "menulogo title" }, "JoinTriage")
                        ], -1)),
                        _createElementVNode("div", _hoisted_4, _toDisplayString($setup.currentUserStore.tenantName), 1)
                    ], 8, _hoisted_3),
                    _createElementVNode("div", {
                        id: "navbarSupportedContent",
                        class: _normalizeClass({ show: $setup.userMenuVisible })
                    }, [
                        _createElementVNode("ul", _hoisted_5, [
                            ($setup.currentUserStore.user)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createVNode($setup["BDropdown"], {
                                        class: "pt-1",
                                        right: "",
                                        "data-cy": "user-dropdown",
                                        size: "md",
                                        text: $setup.currentUserStore.user.name
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode($setup["BDropdownItem"], { disabled: "" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString($setup.currentUserStore.tenantName), 1)
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode($setup["BDropdownDivider"]),
                                            _createVNode($setup["BDropdownItem"], {
                                                "data-cy": "edit-modal-dropdown-item",
                                                onClick: _cache[0] || (_cache[0] = ($event) => ($setup.editUser?.show($setup.currentUserStore.user, true)))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('JTADM_PROFILE')), 1)
                                                ]),
                                                _: 1
                                            }),
                                            ($setup.currentUserStore.isRoot)
                                                ? (_openBlock(), _createBlock($setup["BDropdownItem"], {
                                                    key: 0,
                                                    class: "mt-2",
                                                    "data-cy": "change-tenant-dropdown-item",
                                                    onClick: _withModifiers($setup.tenantSelect, ["prevent"])
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('JTADM_TENANTS_TENANT_SELECT')), 1)
                                                    ]),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true),
                                            _createVNode($setup["BDropdownItem"], {
                                                class: "mt-2",
                                                onClick: _withModifiers($setup.languageSelect, ["prevent"])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('JTADM_LAYOUT_LANGUAGE')), 1)
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode($setup["BDropdownDivider"]),
                                            _createVNode($setup["BDropdownItem"], {
                                                href: _ctx.$t('JTADM_APP_MANUAL_URL'),
                                                target: "_blank"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('JTADM_LAYOUT_APP_MANUAL')), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["href"]),
                                            _createVNode($setup["BDropdownItem"], {
                                                class: "mt-2",
                                                href: _ctx.$t('JTADM_ADMIN_APP_MANUAL_URL'),
                                                target: "_blank"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('JTADM_LAYOUT_ADMIN_MANUAL')), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["href"]),
                                            _createVNode($setup["BDropdownDivider"]),
                                            _createVNode($setup["SignOut"])
                                        ]),
                                        _: 1
                                    }, 8, ["text"])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ], 2)
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
            _createVNode($setup["NavigationMenu"], { class: "col-auto px-0" }),
            _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_router_view, null, {
                        default: _withCtx(({ Component }) => [
                            _createVNode(_Transition, null, {
                                default: _withCtx(() => [
                                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                                ]),
                                _: 2
                            }, 1024)
                        ]),
                        _: 1
                    })
                ])
            ])
        ])
    ], 2));
}
